export const POSTHOG_KEY = "phc_4TFoWZ5mPUE3WILcYvG0SRUCIsK4d2zq8S2p3kmEzzg";
export const POSTHOG_HOST = "https://eu.i.posthog.com";
